// extracted by mini-css-extract-plugin
export default {"purchasesCard":"allPurchasesCard_purchasesCard__PqoC4","purchasesTitle":"allPurchasesCard_purchasesTitle__MdoGp","fixedCell":"allPurchasesCard_fixedCell__9UjWQ"};